import { RuleListModel } from '../../models/RuleListModel';
import { ActionBase } from '../../../core/store/action/ActionBase';

export const ENABLE_RULE = '[Rule] Rule Enable';

export class EnableRuleAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = ENABLE_RULE;

  constructor(public payload: { rule: RuleListModel } ) {}
}



// WEBPACK FOOTER //
// ./src/app/businessRule/store/actions/EnableRuleAction.ts